<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="  mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Service Management </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/serviceinvoice/index">  Manage Service Invoice </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Service Invoice  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2">
  <div class="card-body custom_bdr_rds">


                    <form @submit.prevent="Saveinvoice()" >

                        <div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Booking Number</label>
            <input  v-model="all_data.id"   style="font-size: small;" class="form-control" disabled>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Service Code </label>
            <input  v-model="all_data.job_code"   style="font-size: small;" class="form-control" disabled>
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Engine Number</label>
            <input  v-model="all_data.engi_no"   style="font-size: small;" class="form-control" disabled>
    </div>
  </div>
  
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Model Name </label>
           
            <input v-model="all_data.modelname"   style="font-size: small;" class="form-control" disabled>
            <input v-model="all_data.model_id"  type="hidden" />
    </div>
  </div>

 
</div>

<div class="row">

   

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer </label>
           
            <v-select class="font-size_def" label="value" v-model="all_data.user_full_name" disabled></v-select>

            <input v-model="all_data.user_full_name_id" type="hidden" />
         
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Contact No. </label>
            <!-- <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select> -->
            <input  v-model="all_data.user_contact_tel1"   style="font-size: small;" class="form-control" disabled>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Contact Address </label>
            <!-- <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select> -->
            <v-select class="font-size_def" label="name" v-model="all_data.user_address_line1" :options="technicians" disabled></v-select>
           
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Service Advisor</label>
            <!-- <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select> -->
            <v-select class="font-size_def" label="name" v-model="all_data.advisor_id"  :options="advisors" disabled></v-select>
           
    </div>
  </div>

  

  
</div>


<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks</label>
           <textarea v-model="all_data.inv_remarks" class="form-control" rows="2"></textarea>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Invoiced Date </label>
            <!-- <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select> -->
            <input  v-model="all_data.inv_date"   style="font-size: small;" class="form-control" type="date" required>
    </div>
  </div>



  

</div>


<!-- <div class="row">
  <div class="col-md-3">
    <button type="button"  @click="pendingQuotation()"  class="btn btn-sm  btn-outline-primary mb-1 font-size_def"> View Pending Quotation</button>

    </div>
</div> -->





<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
<h6 class="purchitem mb-2"><b>Available Items for Invoice</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr>


                <th>#</th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Product Description</label>
                  </div>
                </th>
               
                <th class="text_right">
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Qty</label>
                  </div>
                </th>
                <th class="text_right">
                  <div class="form-group custom-form required">
                    <label class="custom-label2">Unit Price</label>
                  </div>
                </th>
                <th class="text_right">
                  <div class="form-group custom-form required">
                    <label class="custom-label2">Discount %</label>
                  </div>
                </th>
                <th class="text_right">
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Line Amount</label>
                  </div>
                </th>
                
                
              
             
            </tr>
          </thead>
          <tbody>

            <tr v-for="(quatation_detail, index) in quatation_details" :key="quatation_detail.id">
                <input v-model="quatation_detail.id" type="hidden"  style="font-size: small;" class="form-control">
                <input v-model="quatation_detail.ave_cost" type="hidden"  style="font-size: small;" class="form-control">
                <input v-model="quatation_detail.avlqty" type="hidden"  style="font-size: small;" class="form-control">
               <td>{{ index+1 }} </td>
              <td style="width: 25%;" >{{quatation_detail.P_code}}</td>
              <td style="width: 25%;" >{{quatation_detail.P_description}}</td>
              <td class="text_right">{{quatation_detail.qty}}</td>
              <td class="text_right">{{quatation_detail.price}}</td>
              <td class="text_right">{{quatation_detail.line_discount}}</td>
              <td class="text_right">{{quatation_detail.line_amount}}</td>
           
              
              
            </tr>
            <tr >
             
             <td></td>
             <td></td>
             <td>Sub Total</td>
             <td></td>
             <td></td>
             
             <td></td>
             <td class="text_right" >{{ totalamt.line_total }}</td>
            
             
           </tr>
           <tr >
             
             <td></td>
             <td></td>
             <td>Special Discount</td>
             <td></td>
             <td></td>
             
           
             <td></td>
             <td class="text_right"> {{all_data.special_discount}}</td>
            
        
             
           </tr>
           <tr >
            
             <td></td>
             <td></td>
             <td>Total</td>
             <td></td>
             <td></td>
             
             <td></td>
             <td class="text_right" >{{  totalamt.fintal_total }}</td>
            
            
             
             
           </tr>


          </tbody>
      </table>

      </div>

</div>
</div>



<br>






    

    <div style="border-bottom: 0px; padding-top: 0px; background-color: #f2f3f4;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    
    this.loadCustomer();

      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        mcustomers:[],
        mproducts:[],
        contacts:[],
      salespeoples:[

      ],
      all_data:{},
      totalamt:{},
        customer:{},
        
        quotation:{},
        sales:{},
        Brands:[],
        quatation_details:[],
        detail:[
      {},  
      ],
      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            // Add more options as needed
        ],
        validity_period: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
            // Add more options as needed
        ],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    

      

        

    
            async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/serviceinvoice/loaddataupdate?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.all_data = data.all_data;
          this.technicians = data.technicians;
          this.advisors = data.advisors;
          this.mproducts = data.mproducts;
          this.quatation_details = data.quatation_details;
          this.totalamt = data.totalamt;
       
         
       } catch (error) {
         console.log(error.response);
       }
     },

    

   

     

     

     



     

     


     





    

    

     

    async Saveinvoice() {
       
      console.log(this.all_data);
    

    
       try {
         const { data} = await  axios.post('/serviceinvoice/create',{id:this.id,userid:this.userid,all_data:this.all_data,quatation_details:this.quatation_details,totalamt:this.totalamt},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
          this.$router.push('/serviceinvoice/view?id='+this.id);
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    